module.exports = __webpack_public_path__ + "img/veritas_pin.0cac111e.jpg";